import axios from "axios";

const apiBaseUrl =
    process.env.VUE_APP_API_URL ||
    "https://eleven-cashier-api.digital-88.com/api";

const instance = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        "Content-Type": "application/json",
    },
});

export default instance;